import { FillAccountError } from "@planzone/dto";
import {
  hasUpperCaseChar,
  hasNumberOrSpecialChar,
  isLongEnough,
  haveMatchingPasswords,
} from "../../entities/passwordValidator";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { findError } from "../../../entities/errorChecker";
import { Interactor } from "./types";

function hasLastName(firstName: string): boolean {
  return firstName.length > 0;
}

function hasFirstName(firstName: string): boolean {
  return firstName.length > 0;
}

function createInteractor(repository: Repository): Interactor {
  return (data) => {
    const error: FillAccountError = {
      emptyLastName: !hasLastName(data.lastName),
      emptyFirstName: !hasFirstName(data.firstName),
      invalidPassword: {
        doesNotHaveNumberOrSpecialChar: !hasNumberOrSpecialChar(data.password),
        doesNotHaveUpper: !hasUpperCaseChar(data.password),
        isTooShort: !isLongEnough(data.password),
      },
      alreadyConfirmed: false,
    };

    return present(
      !findError(error)
        ? repository
            .fillAccount(data.token, {
              firstName: data.firstName,
              lastName: data.lastName,
              password: data.password,
            })
            .catch((e) =>
              Promise.reject({ error: { ...error, ...e }, ...data }),
            )
        : Promise.reject({ error, ...data }),
    );
  };
}

export type { Interactor };

export { createInteractor };
